import React from 'react';
import { Link } from 'react-router-dom';
import { contact, navItems } from '../../data/site';
export function Footer() {
  return <footer className="w-full border-t border-line bg-ink" data-id="element-156" data-mp="eoac1agra4of">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 md:px-10" data-id="element-157" data-mp="alnqfraohfzo">
        <p aria-hidden className="font-serif text-[16vw] leading-[0.85] tracking-[-0.03em] text-paper lg:text-[9rem]" data-id="element-158" data-mp="ao06fywvlga3">
          Bas <span className="italic text-amber" data-id="element-159" data-mp="npv6jueiixk">Menninga</span>
        </p>

        <div className="mt-14 grid grid-cols-1 gap-10 border-t border-line pt-10 sm:grid-cols-2 lg:grid-cols-12" data-id="element-160" data-mp="pu6vnyjkm8e">
          <div className="lg:col-span-5" data-id="element-161" data-mp="3n3kcke4zz1u3">
            <p className="max-w-sm text-[15px] leading-relaxed text-sand" data-id="element-162" data-mp="3n4djbf3yhrc8">
              Singer-songwriter, piano- en gitaardocent uit {contact.location}. Live muziek, muziekles en ukelele-workshops in{' '}
              {contact.region.toLowerCase()}.
            </p>
          </div>
          <nav aria-label="Footer" className="lg:col-span-3" data-id="element-163" data-mp="393j9cs19fibg">
            <p className="text-xs font-semibold uppercase tracking-[0.12em] text-muted" data-id="element-164" data-mp="2kd4nqwdtxmdd">Menu</p>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2" data-id="element-165" data-mp="2kba3zleao0av">
              {navItems.map(item => <li key={item.to} data-id="element-166" data-mp="2bcerxsokjvzn">
                  <Link to={item.to} className="text-[15px] text-sand transition-colors duration-150 hover:text-amber" data-id="element-167" data-mp="2bdhjm2tpu2gm">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
          <div className="lg:col-span-3 lg:col-start-10" data-id="element-168" data-mp="33z9dksx4h1ep">
            <p className="text-xs font-semibold uppercase tracking-[0.12em] text-muted" data-id="element-169" data-mp="381e4vl03lly6">Contact</p>
            <ul className="mt-4 space-y-2 text-[15px]" data-id="element-170" data-mp="2u24n4gw8ujs3">
              <li data-id="element-171" data-mp="2z1r14sjwc41y">
                <a href={contact.phoneHref} className="text-sand transition-colors duration-150 hover:text-amber" data-id="element-172" data-mp="2z17uw93lz43r">
                  {contact.phone}
                </a>
              </li>
              <li data-id="element-173" data-mp="1nmkg9efzkdgz">
                <a href={`mailto:${contact.email}`} className="text-sand transition-colors duration-150 hover:text-amber" data-id="element-174" data-mp="1nnvmdkwwlxb9">
                  {contact.email}
                </a>
              </li>
              <li className="text-muted" data-id="element-175" data-mp="ziw2rwlzrwb3">{contact.location}, Noord-Holland</li>
            </ul>
          </div>
        </div>

        <p className="mt-12 text-sm text-muted" data-id="element-176" data-mp="uqutmjk4elpa">© {new Date().getFullYear()} Bas Menninga</p>
      </div>
    </footer>;
}